module.exports = __webpack_public_path__ + "media/images/emblems/Wappen_rothenthurm-f60b9571c980217e7fe3301d1c9fd364.png";